<template>
  <div>
    <SummaryTile title="Specimena">
      {{ numberOfSpecimena }}
      <v-icon>filter_vintage</v-icon>
    </SummaryTile>
  </div>
</template>

<script>
  import {
    numberWithCommas,
  } from '@/helpers/numbers'
  import SummaryTile from '@/components/MonitoringFeature/DataSources/generic/SummaryTile'

  export default {
    components: {
      SummaryTile,
    },
    props: {
      dataSource: {
        type: Object,
        required: true,
      },
    },
    computed: {
      specimena() {
        return this.dataSource.Specimena || []
      },
      numberOfSpecimena() {
        return numberWithCommas(this.specimena.length)
      },
    },

  }
</script>